// NewsSlider.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, FreeMode, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination'
import './../pagination_fix.sass'

import NewsCard from './NewsCard';

import styles from './../style/News.module.scss';

import SwiperArrowRight from '../icons/SwiperArrowRight';

// NewsSlider.jsx
class NewsSlider extends React.Component {
  constructor(props) {
    super(props);
    this.desktopSwiperRef = React.createRef();
    this.mobileSwiperRef = React.createRef();
    this.nextSlide = this.nextSlide.bind(this);
    this.prevSlide = this.prevSlide.bind(this);
  }

  nextSlide() {
    // Пытаемся найти активный Swiper
    const activeSwiper = this.desktopSwiperRef.current?.swiper || 
                         this.mobileSwiperRef.current?.swiper;
    if (activeSwiper) {
      activeSwiper.slideNext();
    }
  }

  prevSlide() {
    const activeSwiper = this.desktopSwiperRef.current?.swiper || 
                         this.mobileSwiperRef.current?.swiper;
    if (activeSwiper) {
      activeSwiper.slidePrev();
    }
  }

  render() {
    const { news, pagetitle } = this.props;

    return (
      <section className={styles.newsSliderSection}>
        <Container className={styles.container}>
          <div className={styles.sectionHeader}>
            <h1 className={styles.sectionTitle}>{pagetitle}</h1>
          </div>
          
          <div className="d-none d-md-block">
            <Swiper
              ref={this.desktopSwiperRef}
              modules={[Navigation]}
              spaceBetween={5}
              slidesPerView={4}
              autoHeight={false}
              observer={false}
              resizeObserver={false}
              breakpoints={{
                0: {
                  slidesPerView: `auto`,
                  spaceBetween: 5
                },
                992: {
                  slidesPerView: 4,
                  spaceBetween: 20
                }
              }}
            >
              {news.map((item, index) => (
                <SwiperSlide key={index}>
                  <NewsCard newsItem={item} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          
          <div className="d-md-none">
            <Swiper
              ref={this.mobileSwiperRef}
              modules={[Navigation, FreeMode, Pagination]}
              spaceBetween={5}
              slidesPerView={4}
              autoHeight={false}
              pagination={{ type: `progressbar` }}
              observer={false}
              resizeObserver={false}
              breakpoints={{
                0: {
                  slidesPerView: `auto`,
                  spaceBetween: 5,
                  freeMode: true
                },
                992: {
                  slidesPerView: 4,
                  spaceBetween: 20
                }
              }}
            >
              {news.map((item, index) => (
                <SwiperSlide key={index}>
                  <NewsCard newsItem={item} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <div className={styles.swiperControls}>
            <div
              className={`${styles.swiperButton} ${styles.swiperButtonPrev}`}
              onClick={this.prevSlide}
            >
              <SwiperArrowRight style={{ transform: 'rotate(180deg)' }} />
            </div>
            <div
              className={`${styles.swiperButton} ${styles.swiperButtonNext}`}
              onClick={this.nextSlide}
            >
              <SwiperArrowRight />
            </div>
          </div>
        </Container>
      </section>
    );
  }
}

NewsSlider.propTypes = {
  news: PropTypes.array,
  pagetitle: PropTypes.string
};

NewsSlider.defaultProps = {
  news: [],
  pagetitle: `Новости`
};

export default NewsSlider;